module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Tablet.0e4c6712.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Tablet.svg
// module id = 1614
// module chunks = 0